var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.353 3.575C15.978 1.865 13.265.46 10.292.113 7.712-.25 4.864.23 2.875 1.959 1.563 3.065 1.055 4.764.739 6.362.634 7.428.593 8.554.974 9.577c.238.607 1.003.472 1.525.423.274.708.76 1.403 1.526 1.66.829.258 1.834.116 2.45-.512.41-.376.592-.903.783-1.4 2.727.028 5.457.033 8.184-.022.158.53.367 1.077.796 1.46.641.608 1.643.71 2.47.464.77-.256 1.219-.97 1.527-1.656.515.026 1.298.222 1.538-.389.24-.654.175-1.375.146-2.058-.059-1.155-.755-2.305-1.867-2.777-.64-.29-1.128-.801-1.7-1.195zm-3.2-.548a50.836 50.836 0 01-.049 1.536c-1.846.023-3.694-.017-5.541-.019.003-1.08-.052-2.165.025-3.246 1.96.147 3.854.808 5.564 1.729zm-6.847-1.77c.036 1.105.028 2.21 0 3.314-1.903-.013-3.806.009-5.708-.008.34-.919 1.004-1.712 1.84-2.251 1.138-.741 2.524-.976 3.868-1.054zm9.05 3.316c-.318 0-.639-.008-.96-.02l-.001-.66c.336.206.66.43.962.68zm1.116 3.908c.624.39.477 1.49-.273 1.653-.54.21-1.034-.169-1.34-.566.037-.334.003-.716.268-.974.345-.328.952-.374 1.345-.113zM5.285 8.405c.448.211.672.779.451 1.219-.174.47-.769.657-1.234.532-.6-.157-.863-.954-.515-1.44.27-.408.862-.542 1.298-.31z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.88a7043e707a6838c32ba1fb68bd5d8e.svg";
export { ForwardRef as ReactComponent };